import * as Yup from "yup";
import FormikErrorMsgs from "../formikErrorMsgs";
import { useFormik } from "formik";
import AnimatedInput from "../AnimatedInput";
import { useState } from "react";
import Image from "next/image";
import Link from "next/link";
import { apiContactRequestForm } from "./../../helpers/api";
import ReCAPTCHA from "reaptcha";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import useErrorHandling from "../../hooks/useErrorHandling";
const Styles = {
  errorMsg: "text-red-primary text-sm"
};

const options = [
  "Add crypto as currency checkout or payments",
  "Become a partner or reseller"
];

const Spinner = () => (
  <Image src="/loading.png" width={20} height={20} alt="spinner" />
);

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email(FormikErrorMsgs.invalidEmail)
    .required(FormikErrorMsgs.required),
  name: Yup.string().required(FormikErrorMsgs.required),
  BusinessName: Yup.string().required(FormikErrorMsgs.required),
  telegram: Yup.string(),
  whatsApp: Yup.string(),
  website: Yup.string(),
  wantToPartnerOptions: Yup.string()
    .required(FormikErrorMsgs.required)
    .oneOf(options, "Please select an option"),
  message: Yup.string().required(FormikErrorMsgs.required),
  ReCAPTCHA: Yup.string().required(FormikErrorMsgs.required)
});

const ContactUs = () => (
  <div className="pb-12 md:pb-44 space-y-6 flex flex-col items-center lg:items-start justify-center">
    <h1 className={"text-xl lg:text-5xl"}>Contact Us</h1>

    <div className={"space-x-6"}>
      <Link href="https://twitter.com/DataMynt">
        <a target="_blank" rel="noreferrer">
          <Image
            alt="contact image"
            src="/Twitternew.svg"
            width={32}
            height={32}
          />
        </a>
      </Link>
      <Link href="mailto:sales@datamynt.com">
        <a target="_blank" rel="noreferrer">
          <Image
            alt="contact image"
            src="/Gmailnew.svg"
            width={32}
            height={32}
          />
        </a>
      </Link>
      <Link href="https://wa.me/15104937072">
        <a target="_blank" rel="noreferrer">
          <Image
            alt="contact image"
            src="/Whatsappnew.svg"
            width={32}
            height={32}
          />
        </a>
      </Link>
    </div>
  </div>
);

const ContactUsForm = ({ isPress = false }) => {
  const [success, setSuccess] = useState(false);
  const [value, setValue] = useState();
  const { withErrorHandling } = useErrorHandling();
  const [error, setError] = useState("");
  const [recaptchaRef, setRecaptchaRef] = useState(null);

  const resetForm = () => {
    formik.resetForm();
    setError(null);
  };

  const resetReCAPTCHA = () => {
    if (recaptchaRef) {
      recaptchaRef.reset();
    }
  };

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      website: "",
      whatsApp: "",
      BusinessName: "",
      wantToPartnerOptions: "",
      message: "",
      ReCAPTCHA: ""
    },
    validateOnChange: false,

    onSubmit: async values => {
      let contactForm;
      let requestBody = {
        name: values.name,
        email: values.email,
        businessName: values.BusinessName,
        captcha: values.ReCAPTCHA,
        message: values.message,
        help: values.wantToPartnerOptions
      };
      if (values.website) {
        requestBody.website = values.website;
      }
      if (values.whatsApp) {
        requestBody.phone = values.whatsApp;
      }
      try {
        contactForm = await apiContactRequestForm(requestBody);
        if (contactForm.status === 200) {
          setError(null);
          setSuccess(true);
          setTimeout(() => {
            resetForm();
            setSuccess(false);
            resetReCAPTCHA();
          }, 500);
        }
      } catch (err) {
        setError(err.response.data);
        contactForm = await withErrorHandling(
          apiContactRequestForm,
          requestBody,
          err.response.data
        );
      }
    },

    validationSchema,
    enableReinitialize: true
  });

  return (
    <div className="mapBg">
      <div className={"hidden lg:flex"}>
        <ContactUs />
      </div>

      <form
        className="flex flex-col h-full justify-between bg-white rounded-lg lg:rounded-none lg:mb-0 lg:rounded-t-lg shadow-lg p-7 md:p-10 w-full max-w-2xl lg:justify-self-end "
        name="contact"
        method="POST"
        onSubmit={formik.handleSubmit}
      >
        <h1 className="text-black text-[24px] font-bold">
          Please fill this form
        </h1>
        <input type="hidden" name="form-name" value="contact" />
        <AnimatedInput
          isPress
          value={formik.values.BusinessName}
          type="text"
          name="BusinessName"
          required
          onInputChange={formik.handleChange}
        >
          Business Name
        </AnimatedInput>
        <p
          className={formik.errors["BusinessName"] ? Styles.errorMsg : "hidden"}
        >
          {formik.errors["BusinessName"]}
        </p>
        <AnimatedInput
          isPress
          value={formik.values.email}
          type="text"
          name="email"
          required
          onInputChange={formik.handleChange}
        >
          Email address
        </AnimatedInput>
        <p className={formik.errors["email"] ? Styles.errorMsg : "hidden"}>
          {formik.errors["email"]}
        </p>
        <AnimatedInput
          isPress
          value={formik.values.name}
          type="text"
          name="name"
          required
          onInputChange={formik.handleChange}
        >
          Name
        </AnimatedInput>
        <p className={formik.errors["name"] ? Styles.errorMsg : "hidden"}>
          {formik.errors["name"]}
        </p>
        <AnimatedInput
          isPress
          value={formik.values.website}
          type="text"
          name="website"
          onInputChange={formik.handleChange}
        >
          Website if Available
        </AnimatedInput>
        <p className={formik.errors["website"] ? Styles.errorMsg : "hidden"}>
          {formik.errors["website"]}
        </p>
        <div className="border-b border-solid border-gray-30 py-2.5 text-sm  text-gray-80 rounded ">
          <PhoneInput
            className={"input-phone-number"}
            defaultCountry={"US"}
            placeholder="Enter WhatsApp Number"
            name="whatsApp"
            value={formik.values.whatsApp}
            onChange={e => formik.setFieldValue("whatsApp", e)}
          />
        </div>
        <div
          className={`${
            isPress ? "bg-transparent" : "bg-gray-5"
          } mb-2 rounded-lg flex flex-col space-y-2`}
        >
          <p
            className={`${
              isPress ? "text-white" : "text-[#22242C]"
            } text-[16px] font-semibold mt-[24px]`}
          >
            How can we help your business grow?
          </p>
          <div>
            <select
              className="w-full h-12 rounded-lg bg-transparent border-2 border-gray-5 text-[#22242C] font-semibold px-4 text-[16px]"
              name="wantToPartnerOptions"
              onChange={formik.handleChange}
            >
              <option value="" disabled selected>
                Please Select an option
              </option>
              {options.map((option, index) => (
                <option key={index} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>
          <p
            className={
              formik.errors["wantToPartnerOptions"] ? Styles.errorMsg : ""
            }
          >
            {formik.errors["wantToPartnerOptions"]}
          </p>
        </div>
        <div>
          <textarea
            className="w-full h-20 rounded-lg bg-transparent border-2 border-gray-5 text-[#22242C] font-semibold px-4   text-[16px]"
            name="message"
            value={formik.values.message}
            placeholder="What else can we help you with?"
            onChange={formik.handleChange}
          />
          <p className={formik.errors["message"] ? Styles.errorMsg : ""}>
            {formik.errors["message"]}
          </p>
        </div>
        <div className="flex flex-col space-y-2 items-center">
          <ReCAPTCHA
            value={formik.values.ReCAPTCHA}
            sitekey={
              process.env.NEXT_PUBLIC_CONTEXT === "production"
                ? process.env.NEXT_PUBLIC_RECAPTCHA_KEY
                : process.env.NEXT_PUBLIC_RECAPTCHA_TEST_KEY
            }
            onVerify={ReCAPTCHA => formik.setFieldValue("ReCAPTCHA", ReCAPTCHA)}
            ref={e => setRecaptchaRef(e)}
            onChange={() => resetReCAPTCHA(true)}
          />
          <p className={formik.errors["ReCAPTCHA"] ? Styles.errorMsg : ""}>
            {formik.errors["ReCAPTCHA"]}
          </p>
        </div>

        <div className="flex flex-col items-center justify-center">
          {formik.isSubmitting ? (
            <Spinner />
          ) : (
            <button
              type="submit"
              className={
                "bg-[#22242C] w-full px-8 py-2 text-white rounded-[38px] font-bold text-[16px] mt-[10px]"
              }
            >
              Send
            </button>
          )}
          <p className={formik.errors["check"] ? Styles.errorMsg : ""}>
            {formik.errors["check"]}
          </p>
        </div>
        {success && (
          <p className="text-primary">
            Your info was sent successfully! We will get in touch shortly.
          </p>
        )}

        {error && <p className="text-primary">{error.statusMessage}</p>}
      </form>

      <div className={"flex lg:hidden"}>
        <ContactUs />
      </div>
    </div>
  );
};

export default ContactUsForm;
